export const GR_DELIMITER = /~@~/;
